import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { DownloadService } from '@services/download.service';
import { HistoricoConciliacao } from '../models/historico-conciliacao';
import { ConciliacaoDoHistorico } from '../models/conciliacao-do-historico';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class HistoricoConciliacaoApiService extends ApiService {

  baseUrlRoute: string = "historico-conciliacao";

  constructor(
    public override http: HttpClient,
    private downloadService: DownloadService,
    private datePipe: DatePipe,
  ) {
    super(http);
  }

  public getContasBanco(contaId: number): Observable<HistoricoConciliacao> {
    return this.get<HistoricoConciliacao>(`/${this.baseUrlRoute}/${contaId}`);
  }

  public exportarConciliacao(historicoConciliacao: HistoricoConciliacao, conciliacao: ConciliacaoDoHistorico): void {
    const data = this.datePipe.transform(conciliacao.dataUltimoLancamentoBanco, 'yyyy_MM_dd');
    const fileName = `conciliacao_${historicoConciliacao.nomeBanco}_${data}`;
    this.downloadService.downloadFileFromRouteWithParameters(`/conciliacao-excel/${historicoConciliacao.contaBancoId}/exportar-conciliacao/${conciliacao.id}`, fileName, null);
  }
}
